import ImagesCarousel from './ImagesCarousel';

export default ImagesCarousel;
